import axios from "axios";

export function initCheckMaintenance(pageId = "SV-001") {
  return new Promise(function (resolve, reject) {
    if (pageId) {
      checkMaintenance(pageId).then(
        (res) => {
          resolve(res);
        },
        (reason) => {
          return reject(reason);
        }
      );
    } else {
      resolve();
    }
  });
}

export function checkMaintenance(redirectPageId = "") {
  return new Promise(function (resolve, reject) {
    let data = {};
    if (redirectPageId) {
      data["page"] = redirectPageId;
    }
    axios
      .post(
        process.env.VUE_APP_API_CHECK_MAINTENANCE_URL,
        JSON.stringify(data),
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (!res.data.status === "NG") {
          reject(new Error("fail to check/maintenance"));
        }
        let result = res.data.result;
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
